import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getSiteVisitProject(uuid) {
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/site-visit-projects/uuid/${uuid}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function createSiteVisitRequest(payload, isFormData = false) {
    const config = {
        headers: {}
    };

    if (isFormData) {
        // For FormData, let the browser set the Content-Type with boundary
        // Don't set Content-Type manually for FormData
    } else {
        config.headers['Content-Type'] = 'application/json';
    }

    try {
        const { data: response } = await axios.post(`${endpoint}/rest/site-visit-form`, payload, config);
        return response;
    } catch (error) {
        console.error('API Error:', error);
        return {
            success: false,
            status: false,
            message: error.response?.data?.message || 'Something went wrong',
            status: error.response?.status || 500,
            error: error,
        };
    }
}


export { getSiteVisitProject , createSiteVisitRequest};
